import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import { mergePlayers } from './step-services';
import PropTypes from 'prop-types';

var CustomizePlayerFunction = function CustomizePlayerFunction(_ref) {
  var player = _ref.player,
      children = _ref.children,
      playerExtension = _objectWithoutProperties(_ref, ['player', 'children']);

  var newPlayer = mergePlayers(player, playerExtension);
  return children(newPlayer);
};

export { CustomizePlayerFunction };
CustomizePlayerFunction.propTypes = {
  player: PropTypes.object.isRequired
};